/**
 * Ticket contract (RBAC area: `tickets`). A unit of work that is tracked, assigned to
 * one or more members, and has time logged against it.
 *
 * A ticket has one of two origins:
 *   - `project`: belongs to a project (and optionally a phase). Time entries logged on
 *     the ticket default their service category + billing class from the PROJECT.
 *   - `support`: belongs to an agreement and a ticket type. Time entries default their
 *     service category + billing class from the TICKET TYPE.
 *
 * `defaultServiceCategoryId` / `defaultBillingClassId` are the resolved defaults the UI
 * uses to pre-fill a new time entry; they remain user-overridable.
 */
export const TICKET_ORIGINS = ['project', 'support'];
export const TICKET_PRIORITIES = ['low', 'medium', 'high', 'urgent'];
//# sourceMappingURL=ticket.js.map